var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyAnalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2967,
    cy: 40.2967,
    r: 37.7782,
    fill: "#D7D4F8",
    stroke: "#845BB3",
    strokeWidth: 5.03709
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12176_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.296 30.3799C42.4259 30.3799 44.1525 28.6533 44.1525 26.5234C44.1525 24.3935 42.4259 22.6669 40.296 22.6669C38.1661 22.6669 36.4395 24.3935 36.4395 26.5234C36.4395 28.6533 38.1661 30.3799 40.296 30.3799Z",
    fill: "#845BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7617 31.4818H27.8321C27.3389 31.4818 26.866 31.6777 26.5173 32.0264C26.1686 32.3751 25.9727 32.8481 25.9727 33.3412C25.9727 33.8343 26.1686 34.3073 26.5173 34.656C26.866 35.0047 27.3389 35.2006 27.8321 35.2006H34.8482C35.324 35.2006 35.8812 35.4134 36.1966 36.2336C36.565 37.186 36.3846 39.0254 36.1573 40.4503L35.8598 42.1341C35.8604 42.1385 35.8599 42.1429 35.8585 42.1471C35.8571 42.1513 35.8547 42.1551 35.8516 42.1582L33.4688 55.7118C33.3824 56.2038 33.4943 56.71 33.7802 57.1196C34.0661 57.5293 34.5026 57.809 34.9942 57.8976C35.2372 57.9406 35.4864 57.9349 35.7272 57.8808C35.968 57.8267 36.1957 57.7253 36.397 57.5825C36.5983 57.4397 36.7692 57.2583 36.8999 57.0489C37.0305 56.8395 37.1182 56.6062 37.158 56.3626L38.8046 46.9416C38.8046 46.9416 39.3328 44.7042 40.2969 44.7042C41.2769 44.7042 41.794 46.9416 41.794 46.9416L43.4406 56.3708C43.4805 56.6166 43.5688 56.8519 43.7005 57.0632C43.8322 57.2745 44.0047 57.4574 44.2078 57.6013C44.4109 57.7452 44.6407 57.8473 44.8836 57.9016C45.1266 57.9558 45.3779 57.9611 45.623 57.9173C45.8681 57.8734 46.1019 57.7812 46.311 57.646C46.52 57.5108 46.7001 57.3354 46.8407 57.1299C46.9812 56.9245 47.0795 56.6931 47.1297 56.4492C47.18 56.2054 47.1812 55.954 47.1333 55.7097L44.7498 42.1561C44.7503 42.1518 44.7499 42.1474 44.7486 42.1433C44.7473 42.1391 44.7451 42.1353 44.7422 42.132L44.444 40.4482C44.2168 39.0234 44.0363 37.1839 44.4048 36.2315C44.7188 35.4134 45.2938 35.1985 45.7325 35.1985H52.7617C53.2549 35.1985 53.7278 35.0026 54.0765 34.6539C54.4252 34.3052 54.6211 33.8323 54.6211 33.3391C54.6211 32.846 54.4252 32.373 54.0765 32.0243C53.7278 31.6756 53.2549 31.4797 52.7617 31.4797V31.4818Z",
    fill: "#845BB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12176_701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.2596,
    height: 35.2596,
    fill: "white",
    transform: "translate(22.668 22.6669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyAnalysis);
export default __webpack_public_path__ + "static/media/body-analysis.976581774cd859305221b8520b71bc5c.svg";
export { ForwardRef as ReactComponent };